import idx from 'idx';
import partial from 'lodash/partial';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setCurrentRevision } from 'focus_groups/ducks/results';

import ModalDialog from 'common/components/modal/modal_dialog';

export function mapStateToProps(state) {
  const show = !!idx(state, _ => _.project.focusGroups.results.currentRevisionId);

  return {
    dialogClasses: 'focus-group-comments-modal',
    contentClasses: 'wide',
    modalOpen: show,
    showClose: true,
    modalHeader: "Entry Results"
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    closeAction: partial(setCurrentRevision, null),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalDialog);



// WEBPACK FOOTER //
// ./focus_groups/containers/result_modal.js